<template>
  <div class="menu-tab-btn-wrap">
    <div class="menu-tab-btn__track" :style="trackStyle"></div>
    <button 
      v-for="(item, index) in data" 
      :key="index" 
      ref="items"
      class="menu-tab-btn__item" 
      :class="{ 'menu-tab-btn__item--active': value === item.value }"
      @click="changeMethod(item)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      trackStyle: {
        width: '0px',
        transform: 'translateX(0)'
      }
    }
  },
  watch: {
    value: {
      handler: 'updateTrack',
      immediate: true
    },
    data: 'updateTrack'
  },
  mounted() {
    this.$nextTick(this.updateTrack)
    window.addEventListener('resize', this.updateTrack)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTrack)
  },
  methods: {
    changeMethod(item) {
      this.$emit('change', item.value)
    },
    updateTrack() {
      this.$nextTick(() => {
        if (!this.$refs.items || !this.$refs.items.length) return
        
        const index = this.data.findIndex(item => item.value === this.value)
        if (index === -1) return

        const activeEl = this.$refs.items[index]
        const parentRect = this.$el.getBoundingClientRect()
        const elRect = activeEl.getBoundingClientRect()
        
        const width = elRect.width
        const left = elRect.left - parentRect.left

        this.trackStyle = {
          width: `${width - 8}px`, // 减去内边距
          transform: `translateX(${left + 4}px)` // 加上内边距偏移
        }
      })
    }
  }
}
</script>

<style lang="less">
.menu-tab-btn-wrap {
  position: relative;
  background: @primary-color-alpha-1; // 替换为主题色
  height: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 4px;
  overflow: hidden;
  color: @text-color-secondary; // 替换为次文本色
  user-select: none;
  isolation: isolate;

  .menu-tab-btn__track {
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 0;
    background: @primary-color; // 激活状态背景色
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
    z-index: 1;
    pointer-events: none;
  }

  .menu-tab-btn__item {
    position: relative;
    z-index: 2;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: color 0.2s ease;
    padding: 0 12px;
    white-space: nowrap;
    outline: none;
    color: inherit;

    &:hover:not(.menu-tab-btn__item--active) {
      color: @text-color; // hover 颜色
    }

    &.menu-tab-btn__item--active {
      color: @text-color; // 激活文本色
      font-weight: 600;
    }
  }
}
</style>
